import { useMutation, useQueryClient } from "@tanstack/react-query";
import { templateBuilderMutations } from "@/features/template-builder/mutations";
import { insertCachedTemplateStep } from "@/features/template-builder/queries/cache";

export type InsertStepAtPositionParams = {
  templateId: string;
  position: number;
  templateStepId?: string;
};

export function useInsertStepAtPosition() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: InsertStepAtPositionParams) =>
      templateBuilderMutations.createTemplateStep(params),
    onSuccess: (step, { templateId }) => {
      insertCachedTemplateStep(queryClient, templateId, step);
    },
  });
}
